import styles from '../CommonCss/OrderEngineCommon.module.css'
import ModalWindow from "../../../FormTemplate/ModalWindow/ModalWindow";
import MainFormTemplate from "../../../FormTemplate/MainFormTemplate/MainFormTemplate";
import InputItem from "../../../FormTemplate/InputItem/InputItem";
import ErrorLineItem, {ErrorLineItemRef} from "../../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useEffect, useRef, useState} from "react";
import useApiQuery from "../../../ApiQuery/UseApiQuery";
import WaitLoader from "../../../WaitLoader/WaitLoader";


interface UpdateOrderInt
{
    orderId:string
    id?:number
    fieldList: string[]
    valList: any[]
    mode:number
}

interface OrderEngineSimPropsInt
{
    orderId:string
    pIcc:string
    pCtn:string
    pTempCtn:string

    onClose: ()=>void
    onSuccess?: ()=>void


}

export default function OrderEngineSim({orderId,pIcc,pCtn,onClose,onSuccess,pTempCtn}:OrderEngineSimPropsInt){

    const orderUpdateData = useRef<UpdateOrderInt>()
    const [ldrOrderUpdate,rsOrderUpdate,exOrderUpdate] = useApiQuery("/sell/sim/order/update/field","post",orderUpdateData);


    const updateSim = useRef<ErrorLineItemRef>(null)

    const [icc, setIcc] = useState(pIcc )
    const [ctn, setCtn] = useState(pCtn )
    const [tempCtn, setTempCtn] = useState(pTempCtn )
    const [valid, setValid] = useState(false)

    useEffect(()=>{
        const vIcc = icc?.match(/^[0-9]{15,22}$/ui)
        const vCtn = ctn?.match(/^[0-9]{10}$/ui)
        const vTempCtn = tempCtn?.match(/^[0-9]{10}$/ui)
        if(vCtn && vIcc ) setValid(true)
        else setValid(false)


    },[ctn,icc])


    const handleUpdateSim = () =>{
        const x = tempCtn?.match(/^[0-9]{10}$/ui)
        const vTempCtn = x ? x[0] : null

        orderUpdateData.current = {
            orderId: orderId,
            mode:0,

            fieldList: ["icc","ctn","tempCtn"],
            valList:[icc?.trim(), ctn?.trim(), vTempCtn]
        }
        exOrderUpdate().then((e)=>{
            if(e?.success)
            {
                if(updateSim.current)updateSim.current.show(`SIM в заказа ${orderId} обновлена`,false,0)
                if(onSuccess) onSuccess()
                return
            }
            if(updateSim.current)updateSim.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)
        }).catch((e)=>{
            if(updateSim.current)updateSim.current.show(e?.errorAsString ? e?.errorAsString :"Ошибка сервера",true,3000)

        })

    }


    return(
        <ModalWindow>
            <MainFormTemplate title={`SIM Карта`} maxWidth={"450px"} background={"white"}>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={icc}
                            mode={"ie"}
                            info={"ICC"}
                            title={"ICC"}
                            titleShift={0}
                            onTitleDoubleClick={()=>setIcc("000000000000000")}
                            regExp={/^[0-9]{15,22}$/}
                            onChange={(e)=>{
                                setIcc(e)
                            }}
                        ></InputItem>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={ctn}
                            mode={"ie"}
                            info={"Номер [XXXXXXXXXX]"}
                            title={"Номер"}
                            regExp={/^[0-9]{10}$/}
                            titleShift={0}
                            onChange={(e)=>{
                                setCtn(e)
                            }}
                        ></InputItem>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-12"}>
                        <InputItem
                            val={tempCtn}
                            mode={"ie"}
                            info={"Временный номер"}
                            title={"Врем. номер"}
                            titleShift={0}
                            regExp={/(^[0-9]{10}$)|(^$)/}
                            onChange={(e)=>{
                                setTempCtn(e)
                            }}
                        ></InputItem>
                    </div>
                </div>
                <ErrorLineItem ref={updateSim} ></ErrorLineItem>

                <div className={styles.actCont}>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                disabled={!valid}
                                onClick={(e)=>{
                                    handleUpdateSim()
                                }}
                        >Обновить</button>
                    </div>
                    <div className={styles.btnCont}>
                        <button type="button" className="btn btn-secondary "
                                onClick={(e)=>{
                                    onClose()
                                }}
                        >Закрыть</button>
                    </div>
                    <WaitLoader loading={ldrOrderUpdate } api={rsOrderUpdate} onlyLoading={true}>

                    </WaitLoader>

                </div>

            </MainFormTemplate>
        </ModalWindow>
    )
}